import { createStore, applyMiddleware } from "redux";
import { combineReducers } from "redux";
import { bookReducer } from "./book/bookReducer";
import reduxLogger from "redux-logger";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import { loadingBarReducer } from "react-redux-loading-bar";

let _store = {};
const combinedReducers = combineReducers({
  bookReducer,
  loadingBar: loadingBarReducer,
});
if (process.env.NODE_ENV === "development") {
  _store = createStore(
    combinedReducers,
    composeWithDevTools(applyMiddleware(reduxLogger, thunk))
  );
} else {
  _store = createStore(combinedReducers, applyMiddleware(thunk));
}

export const store = _store;
